import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { ContactMechanismTypes } from '../../party/model/contact-mechanism-types.model';

@Injectable({
    providedIn: 'root'
})
export class ContactMechanismEntityService extends EntityCollectionServiceBase<ContactMechanismTypes> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('ContactMechanism', serviceElementsFactory);
    }
}
